var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page",attrs:{"id":"orgs"}},[_c('h2',{staticClass:"display-4"},[_vm._v("Organizzazioni")]),_c('hr'),_c('OrgList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }